var exports = {
  "wZ": "commentIconWithIndicator__zq3TaX",
  "Ls": "commentIcon__1KTjXg",
  "ED": "ActionMenuButton__ubvrQl",
  "qj": "copilotIcon__2ymnat",
  "B1": "assignedToCopilotText__2bm4OI",
  "IC": "assignedToCopilotStatus__B2ch2h",
};

module.exports = exports;
